import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetConnectPromotionUtils(club) {
  var url = "/reservation/connect_promotions_data_utils/" + club;

  return FetchGetDataWithAuthNEW(url);
}
